import { $ } from "@/common/Axios";

export default {
  /**
   * 学生教学-选修课情况
   */
  studentElective_register: {
    /*
     * 后台报名（不受报名时间限制）
     * planId 教学计划id (integer query required)
     * schoolRollId 学生合同id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/education/studentElective/register", p, c),
  },
  studentElective_cancel: {
    /*
     * 后台取消（不受报名时间限制，可取消必选课）
     * planId 教学计划id (integer query required)
     * schoolRollId 学生合同id (integer query required)
     * cancelReason 取消原因 (string query )
     */
    post: (p, c) => $.post("/api/cms/education/studentElective/cancel", p, c),
  },
  studentElective_list: {
    /*
     * 选修课情况列表
     */
    get: (p, c) => $.get("/api/cms/education/studentElective/list", p, c),
  },
  studentElective_export: {
    /*
     * 选修课情况导出
     */
    get: (p, c) => $.get("/api/cms/education/studentElective/export", p, c),
  },
  studentElective_exportDetail: {
    /*
     * 选修课情况详情导出
     * siteId 学校id (integer query required)
     * classRoomId 班级id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/education/studentElective/exportDetail", p, c),
  },
  studentElective_detail: {
    /*
     * 选修课情况详情
     * schoolRollId 学生合同id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/education/studentElective/detail", p, c),
  },
};
